<template>
  <button
    type="button"
    class="row"
    :class="{ 'row--active': isActive, 'row--closed': isClosed }"
    @click="select(chat)"
  >
    <span class="row__avatar">{{ initialsText }}</span>
    <span class="row__body">
      <span class="row__top">
        <span class="row__name">{{ title }}</span>
        <span class="row__time">{{ time }}</span>
      </span>
      <span class="row__bottom">
        <span class="row__snippet" :class="{ 'row__snippet--closed': isClosed }">
          {{ isClosed ? 'Чат приостановлен' : snippet }}
        </span>
        <span class="row__unread" v-if="hasUnread" aria-label="Есть непрочитанные"></span>
      </span>
    </span>
  </button>
</template>

<script>
import { formatChatListTime } from './utils/datetime';
import { initials } from './utils/text';

export default {
  name: 'ChatPreview',
  props: {
    chat: { type: Object, required: true },
    currentChatId: { type: Number, default: -1 },
    currentProfileId: { type: Number, default: null },
    select: { type: Function, required: true },
  },
  computed: {
    lastMessage() {
      return (this.chat.messages && this.chat.messages[0]) || null;
    },
    isActive() {
      return this.currentChatId === this.chat.id;
    },
    isClosed() {
      if (!this.chat.deleted) return false;
      const t = new Date(this.chat.deleted).getTime();
      return !isNaN(t) && Date.now() > t;
    },
    title() {
      const doctors = (this.chat.users || [])
        .filter((u) => u.type === 'doctor')
        .map((u) => u.name)
        .filter(Boolean);
      if (doctors.length) return doctors.join(', ');
      const others = (this.chat.users || [])
        .filter((u) => u.id !== this.currentProfileId)
        .map((u) => u.name)
        .filter(Boolean);
      return others.join(', ') || 'Чат';
    },
    initialsText() {
      return initials(this.title);
    },
    snippet() {
      return this.lastMessage ? this.lastMessage.content || '📎 Вложение' : '';
    },
    time() {
      return this.lastMessage ? formatChatListTime(this.lastMessage.created) : '';
    },
    hasUnread() {
      const last = this.lastMessage;
      if (!last || !last.user || this.currentProfileId == null) return false;
      if (last.user.id === this.currentProfileId) return false;
      const seenIds = (last.seen || []).map((s) => s.id);
      return !seenIds.includes(this.currentProfileId);
    },
  },
};
</script>

<style scoped>
.row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  font: inherit;
  color: var(--text, #1f2733);
}

.row:hover {
  background: var(--surface-2, #eef6fa);
}

.row--active {
  background: var(--accent-soft, #d7eef5);
}

.row--closed {
  opacity: 0.55;
}

.row__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e3e8ec);
  color: var(--accent, #0b89ac);
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}

.row--active .row__avatar {
  background: var(--accent, #0b89ac);
  border-color: transparent;
  color: #fff;
}

.row__body {
  min-width: 0;
  flex: 1;
}

.row__top {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.row__name {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text, #1f2733);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row__time {
  flex-shrink: 0;
  font-size: 11px;
  color: var(--text-muted, #6b7681);
  font-variant-numeric: tabular-nums;
}

.row__bottom {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 1px;
}

.row__snippet {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: var(--text-muted, #6b7681);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row__snippet--closed {
  font-style: italic;
}

.row__unread {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent, #0b89ac);
}
</style>
